export const fieldTypesToCategories: Record<string, string> = {
  text: "literal",
  acknowledge: "literal",
  integer: "literal",
  decimal: "literal",
  range: "literal",
  barcode: "literal",
  select_one: "choice",
  select_one_from_file: "choice",
  select_multiple: "choice",
  select_multiple_from_file: "choice",
  rank: "choice",
  geopoint: "geo",
  geotrace: "geo",
  geoshape: "geo",
  date: "time",
  time: "time",
  datetime: "time",
  image: "media",
  audio: "media",
  video: "media",
  file: "media",
  note: "special",
  calculate: "special",
  hidden: "special",
  "xml-external": "special",
  start: "stats",
  end: "stats",
  today: "stats",
  deviceid: "track",
  simserial: "track",
  subscriberid: "track",
  phonenumber: "track",
  username: "track",
  email: "track",
  audit: "track",
  begin_group: "grouping",
  begin_repeat: "grouping",
};
